(function () {
  if (window.__kushaeCartRecommendationsInitialized) return;
  window.__kushaeCartRecommendationsInitialized = true;

  var SOURCE_SELECTOR = '[data-kushae-cart-recommendations-source]';
  var ADD_SELECTOR = '[data-kushae-cart-recommendation-add]';
  var insertedRecommendations = null;
  var insertedBanner = null;
  var refreshTimer = null;
  var refreshInFlight = false;
  var refreshPending = false;
  var refreshSequenceTimers = [];
  var preserveAddedBannerUntil = 0;
  var drawerReadyRetryTimer = null;
  var drawerReadyRetryCount = 0;
  var debugState = {
    loaded: true,
    refreshes: 0,
    renderAttempts: 0,
    lastEvent: '',
    lastBlockReason: '',
    lastCart: null,
    lastDrawer: null,
    lastSource: null,
    lastRecommendationCount: 0,
    lastError: ''
  };

  window.KushaeCartRecommendationsDebug = window.KushaeCartRecommendationsDebug || {};
  window.KushaeCartRecommendationsDebug.state = debugState;

  function debugEnabled() {
    return window.KUSHAE_CART_RECOMMENDATIONS_DEBUG === true;
  }

  function logDebug(label, data) {
    debugState.lastEvent = label;
    if (debugEnabled()) {
      console.log('[KushaeCartRecommendations] ' + label, data || '');
    }
  }

  function parseRecommendationsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    updateCartImageMap(doc);
    var source = doc.querySelector(SOURCE_SELECTOR);
    return source ? source.querySelector('.kushae-cart-recommendations') : null;
  }

  function normalizeProductPath(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return String(url).split(/[?#]/)[0].replace(/\/$/, '');
    }
  }

  function updateCartImageMap(root) {
    var imageMap = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-kushae-cart-image]'), function (entry) {
      var productPath = normalizeProductPath(entry.getAttribute('data-product-url'));
      var src = entry.getAttribute('data-image-src');
      if (!productPath || !src) return;
      imageMap[productPath] = {
        src: src,
        srcset: entry.getAttribute('data-image-srcset') || ''
      };
    });
    window.KushaeCartBlogImages = imageMap;
    document.dispatchEvent(new CustomEvent('kushae:cartimagemapchanged'));
  }

  function getCurrentRecommendations() {
    var source = document.querySelector(SOURCE_SELECTOR);
    return source ? source.querySelector('.kushae-cart-recommendations') : null;
  }

  function getDrawer() {
    return document.getElementById('slidecarthq');
  }

  function updateHeaderCartCount(count) {
    var itemCount = Number(count) || 0;
    Array.prototype.forEach.call(document.querySelectorAll('.cart-link__icon'), function (icon) {
      var countNode = icon.querySelector('.cart-link__count');

      if (itemCount < 1) {
        if (countNode) countNode.remove();
        return;
      }

      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'cart-link__count';
        icon.appendChild(countNode);
      }

      countNode.textContent = String(itemCount);
    });
  }

  function getFooter(drawer) {
    return drawer ? drawer.querySelector('footer.footer, .footer.cdr-summary-footer, .footer') : null;
  }

  function getDrawerSnapshot(drawer) {
    var footer = getFooter(drawer);
    return {
      exists: !!drawer,
      className: drawer ? drawer.className : '',
      hasEmpty: !!(drawer && drawer.querySelector('.empty')),
      hasCartEmptyClass: !!(drawer && drawer.classList.contains('cartEmpty')),
      itemCount: drawer ? drawer.querySelectorAll('.items .item').length : 0,
      hasFooter: !!footer,
      hasRecommendations: !!(drawer && drawer.querySelector('.kushae-cart-recommendations')),
      text: drawer ? (drawer.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 180) : ''
    };
  }

  function drawerHasCartItems(drawer) {
    return !!(drawer && !drawer.classList.contains('cartEmpty') && !drawer.querySelector('.empty') && drawer.querySelector('.items .item'));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateFooterShift(footer, fromTop) {
    if (!footer || prefersReducedMotion()) return;

    var toTop = footer.getBoundingClientRect().top;
    var delta = fromTop - toTop;
    if (Math.abs(delta) < 2) return;

    footer.classList.add('cdr-routine-shift');
    footer.style.transform = 'translateY(' + delta + 'px)';
    footer.getBoundingClientRect();
    window.requestAnimationFrame(function () {
      footer.style.transform = '';
      window.setTimeout(function () {
        footer.classList.remove('cdr-routine-shift');
      }, 560);
    });
  }

  function retryWhenDrawerIsStillRendering(reason) {
    if (drawerReadyRetryCount >= 12) return;
    drawerReadyRetryCount += 1;
    debugState.lastBlockReason = reason;
    window.clearTimeout(drawerReadyRetryTimer);
    drawerReadyRetryTimer = window.setTimeout(requestRecommendationsRefresh, 350);
  }

  function renderRecommendations(recommendations) {
    var drawer = getDrawer();
    debugState.renderAttempts += 1;
    var hadRecommendations = !!(insertedRecommendations && insertedRecommendations.parentNode);
    if (insertedRecommendations && insertedRecommendations.parentNode) {
      insertedRecommendations.parentNode.removeChild(insertedRecommendations);
    }
    insertedRecommendations = null;

    var footer = getFooter(drawer);
    if (drawer) drawer.classList.remove('cdr-has-routine-recommendations');
    debugState.lastDrawer = getDrawerSnapshot(drawer);
    debugState.lastRecommendationCount = recommendations ? recommendations.querySelectorAll('.kushae-cart-recommendations__card').length : 0;

    if (!drawer) {
      debugState.lastBlockReason = 'no_drawer';
      logDebug('render blocked', debugState.lastBlockReason);
      return;
    }

    if (!footer) {
      debugState.lastBlockReason = 'no_footer';
      logDebug('render blocked', debugState.lastBlockReason);
      retryWhenDrawerIsStillRendering('no_footer');
      return;
    }

    if (!recommendations) {
      debugState.lastBlockReason = 'no_recommendations_from_liquid';
      logDebug('render blocked', debugState.lastBlockReason);
      return;
    }

    if (!drawerHasCartItems(drawer)) {
      debugState.lastBlockReason = 'drawer_not_ready_or_empty';
      logDebug('render blocked', debugState.lastDrawer);
      retryWhenDrawerIsStillRendering('drawer_not_ready_or_empty');
      return;
    }

    if (document.body) document.body.classList.add('cart-drawer-redesign-enabled');

    var footerTop = footer.getBoundingClientRect().top;
    insertedRecommendations = recommendations.cloneNode(true);
    if (!hadRecommendations) insertedRecommendations.classList.add('is-entering');
    drawer.classList.add('cdr-has-routine-recommendations');
    footer.insertAdjacentElement('beforebegin', insertedRecommendations);
    if (!hadRecommendations) animateFooterShift(footer, footerTop);
    window.setTimeout(function () {
      if (insertedRecommendations) insertedRecommendations.classList.remove('is-entering');
    }, 560);
    debugState.lastBlockReason = '';
    debugState.lastDrawer = getDrawerSnapshot(drawer);
    logDebug('rendered recommendations', debugState.lastDrawer);
  }

  function requestRecommendationsRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      if (refreshInFlight) {
        refreshPending = true;
        return;
      }

      refreshInFlight = true;
      debugState.refreshes += 1;
      debugState.lastError = '';
      logDebug('refresh start', { refreshes: debugState.refreshes, retry: drawerReadyRetryCount });
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          debugState.lastCart = cart ? {
            item_count: cart.item_count,
            total_price: cart.total_price,
            item_titles: (cart.items || []).map(function (item) { return item.product_title || item.title; })
          } : null;
          logDebug('/cart.js result', debugState.lastCart);
          if (cart) updateHeaderCartCount(cart.item_count);

          if (!cart || cart.item_count < 1) {
            window.clearTimeout(drawerReadyRetryTimer);
            renderRecommendations(null);
            return '';
          }

          if (!drawerHasCartItems(getDrawer())) {
            debugState.lastDrawer = getDrawerSnapshot(getDrawer());
            debugState.lastBlockReason = 'cart_has_items_drawer_not_ready';
            logDebug('drawer not ready for recommendations', debugState.lastDrawer);
            renderRecommendations(null);
            retryWhenDrawerIsStillRendering('cart_has_items_drawer_not_ready');
            return '';
          }

          drawerReadyRetryCount = 0;

          return fetch('/cart', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (response) {
              return response.ok ? response.text() : '';
            });
        })
        .then(function (html) {
          if (!html) return;
          var recommendations = parseRecommendationsFromHtml(html);
          debugState.lastSource = {
            hasSource: html.indexOf('data-kushae-cart-recommendations-source') !== -1,
            hasRecommendations: !!recommendations,
            cardCount: recommendations ? recommendations.querySelectorAll('.kushae-cart-recommendations__card').length : 0
          };
          logDebug('/cart liquid result', debugState.lastSource);
          renderRecommendations(recommendations);
        })
        .catch(function (error) {
          debugState.lastError = error && error.message ? error.message : String(error || 'unknown_error');
          logDebug('refresh error', debugState.lastError);
          renderRecommendations(null);
        })
        .then(function () {
          refreshInFlight = false;
          if (refreshPending) {
            refreshPending = false;
            requestRecommendationsRefresh();
          }
        });
    }, 150);
  }

  function requestRecommendationsRefreshSequence() {
    logDebug('refresh sequence requested');
    refreshSequenceTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    window.clearTimeout(drawerReadyRetryTimer);
    drawerReadyRetryCount = 0;
    refreshSequenceTimers = [0, 350, 900, 1600, 2400, 4000, 6000].map(function (delay) {
      return window.setTimeout(requestRecommendationsRefresh, delay);
    });
  }

  function bindCartAddFetchWatcher() {
    if (window.__kushaeCartRecommendationsFetchWatcher) return;
    window.__kushaeCartRecommendationsFetchWatcher = true;

    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function () {
      var responsePromise = nativeFetch.apply(this, arguments);

      responsePromise.then(function (response) {
        var url = response && response.url ? response.url : '';
        if (response && response.ok && /\/cart\/add\.js(?:[?#].*)?$/i.test(url)) {
          requestRecommendationsRefreshSequence();
        }
      }).catch(function () {});

      return responsePromise;
    };
  }

  function showAddedBannerSequence(data) {
    [0, 250, 700].forEach(function (delay) {
      window.setTimeout(function () {
        if (Date.now() <= preserveAddedBannerUntil) {
          showAddedBanner(data);
        }
      }, delay);
    });
  }

  function checkIconSvg() {
    return '<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.59041 11.9056L0 6.31519L0.802688 5.5125L5.59041 10.3002L15.8906 0L16.6933 0.802687L5.59041 11.9056Z" fill="white"/></svg>';
  }

  function clearAddedBanner() {
    if (insertedBanner && insertedBanner.parentNode) {
      insertedBanner.parentNode.removeChild(insertedBanner);
    }
    insertedBanner = null;
  }

  function showAddedBanner(data) {
    var drawer = getDrawer();
    if (!drawer) return;
    if (document.body) document.body.classList.add('cart-drawer-redesign-enabled');

    var header = drawer.querySelector('header.header[data-testid="Header"], header.header');
    var progress = drawer.querySelector('.rewards[data-testid="TieredRewards"], .rewards');
    var title = data.title || '';
    var image = data.image || '';

    if (insertedBanner && insertedBanner.parentNode) {
      insertedBanner.parentNode.removeChild(insertedBanner);
    }

    insertedBanner = document.createElement('div');
    insertedBanner.className = 'kushae-cart-added-banner';
    insertedBanner.setAttribute('role', 'status');
    insertedBanner.setAttribute('aria-live', 'polite');
    insertedBanner.innerHTML =
      '<div class="kushae-cart-added-banner__media">' +
      (image ? '<img class="kushae-cart-added-banner__image" src="' + image + '" alt="">' : '') +
      '</div>' +
      '<div class="kushae-cart-added-banner__content">' +
      '<div class="kushae-cart-added-banner__row">' +
      '<span class="kushae-cart-added-banner__check" aria-hidden="true">' + checkIconSvg() + '</span>' +
      '<p class="kushae-cart-added-banner__message">Added to your cart!</p>' +
      '</div>' +
      '<p class="kushae-cart-added-banner__title"></p>' +
      '</div>';

    var titleNode = insertedBanner.querySelector('.kushae-cart-added-banner__title');
    if (titleNode) titleNode.textContent = title;

    if (progress && progress.parentNode) {
      progress.parentNode.insertBefore(insertedBanner, progress);
    } else if (header && header.parentNode) {
      header.parentNode.insertBefore(insertedBanner, header.nextSibling);
    } else {
      drawer.insertBefore(insertedBanner, drawer.firstChild);
    }
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  }

  function syncSlideCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        if (typeof window.SLIDECART_SET_CART === 'function') {
          window.SLIDECART_SET_CART(cart);
        } else if (typeof window.SLIDECART_UPDATE === 'function') {
          window.SLIDECART_UPDATE(cart);
        }
      })
      .catch(function () {});
  }

  function setButtonState(button, state) {
    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'ADDING';
    } else if (state === 'added') {
      button.disabled = true;
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'ADDED';
    } else {
      button.disabled = false;
      button.classList.remove('is-loading', 'is-added');
      button.textContent = 'ADD';
    }
  }

  function addRecommendation(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    setButtonState(button, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function () {
        setButtonState(button, 'added');
        var bannerData = {
          title: button.getAttribute('data-product-title'),
          image: button.getAttribute('data-product-image')
        };
        preserveAddedBannerUntil = Date.now() + 2500;
        showAddedBannerSequence(bannerData);
        syncSlideCart();
        notifyCartChanged();
        requestRecommendationsRefresh();
      })
      .catch(function () {
        setButtonState(button, 'default');
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest ? event.target.closest('#slidecarthq button[aria-label="close cart"]') : null;
      if (closeButton) {
        clearAddedBanner();
      }

      var button = event.target.closest ? event.target.closest(ADD_SELECTOR) : null;
      if (!button) return;
      event.preventDefault();
      addRecommendation(button);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('#slidecarthq')) return;
      if (event.target.closest('.quantity-selector button, button.remove, .remove, [data-testid*="quantity"], [data-testid*="remove"]')) {
        if (Date.now() > preserveAddedBannerUntil) {
          clearAddedBanner();
        }
        requestRecommendationsRefreshSequence();
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('#slidecarthq')) return;
      if (event.target.closest('.quantity-selector input, input[type="number"], select')) {
        if (Date.now() > preserveAddedBannerUntil) {
          clearAddedBanner();
        }
        requestRecommendationsRefreshSequence();
      }
    });

    document.addEventListener('theme:cartchanged', requestRecommendationsRefreshSequence);
    document.documentElement.addEventListener('theme:cartchanged', requestRecommendationsRefreshSequence);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindEvents();
    bindCartAddFetchWatcher();
    updateCartImageMap(document);
    window.KushaeCartRecommendationsDebug.refresh = requestRecommendationsRefreshSequence;
    window.KushaeCartRecommendationsDebug.snapshot = function () {
      debugState.lastDrawer = getDrawerSnapshot(getDrawer());
      return debugState;
    };
    renderRecommendations(getCurrentRecommendations());
    requestRecommendationsRefresh();
  });
})();
